import {PanelConfigSpecToProps} from '../property-editors/property-editors';
import * as Panels from '../../util/panels';
import React from 'react';
import {configSpec} from './common';
import * as QueryTS from '../../util/queryts';
import {toRunsDataQuery} from '../../containers/RunsDataLoader';

const PANEL_TYPE = 'Vega3';

/* eslint-enable no-template-curly-in-string */

function transformQuery(
  query: QueryTS.Query,
  config: PanelConfigSpecToProps<typeof configSpec>
) {
  // We always disable this query, and instead use our own internal RunsDataLoader.
  // We need to do this because the query we want to run actually depends on another
  // query (the vegaPanelQuery which asks for user configured views from the views
  // table), which depends on the current panel configuration.
  const result = toRunsDataQuery(query);
  result.disabled = true;
  return result;
}

export const Spec: Panels.PanelSpec<
  typeof PANEL_TYPE,
  PanelConfigSpecToProps<typeof configSpec>
> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  configSpec,
  useInspector: true,
  transformQuery,
};
